/* ==========================================================================
   DIANDA TRAVEL — Blog Landing Page 交互脚本
   页面定位：China Travel Inspiration + Travel Guides
   ==========================================================================
   设计原则：
   - 无依赖、轻量
   - 只做 transform / opacity / 类切换，避免触发重排
   - 所有查询都限定在 .dd-blog 内，避免污染其他页面
   ========================================================================== */
(function () {
    'use strict';

    /* ------------------------------------------------------------------
       1. Travel Planning Guides 选项卡（Visa / Payment / Internet / Transport）
       支持键盘左右方向键切换，符合 ARIA tablist 语义
       ------------------------------------------------------------------ */
    document.querySelectorAll('[data-dd-tabs]').forEach(function (tabs) {
        var buttons = Array.prototype.slice.call(tabs.querySelectorAll('.dd-guides__tab'));
        var panels = Array.prototype.slice.call(tabs.querySelectorAll('.dd-guides__panel'));
        if (!buttons.length || !panels.length) return;

        function activate(index) {
            buttons.forEach(function (btn, i) {
                var isActive = i === index;
                btn.classList.toggle('is-active', isActive);
                btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
                btn.tabIndex = isActive ? 0 : -1;
            });

            panels.forEach(function (panel, i) {
                var isActive = i === index;
                panel.classList.toggle('is-active', isActive);
                if (isActive) {
                    panel.removeAttribute('hidden');
                } else {
                    panel.setAttribute('hidden', '');
                }
            });
        }

        buttons.forEach(function (btn, i) {
            btn.addEventListener('click', function () {
                activate(i);
            });
        });

        // 键盘左右方向键切换，回车/空格默认触发 click
        tabs.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            var current = buttons.indexOf(document.activeElement);
            if (current === -1) return;
            e.preventDefault();
            var next = (current + (e.key === 'ArrowRight' ? 1 : buttons.length - 1)) % buttons.length;
            activate(next);
            buttons[next].focus();
        });

        // 默认激活第一个
        activate(0);
    });
})();
